<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="48"
    width="48"
    viewBox="0 0 48 48"
  >
    <path
      d="M27.5 17.5q-.65 0-1.075-.425Q26 16.65 26 16q0-.65.425-1.075.425-.425 1.075-.425h15q.65 0 1.075.425Q44 15.35 44 16q0 .65-.425 1.075-.425.425-1.075.425Zm0 16q-.65 0-1.075-.425Q26 32.65 26 32q0-.65.425-1.075.425-.425 1.075-.425h15q.65 0 1.075.425Q44 31.35 44 32q0 .65-.425 1.075-.425.425-1.075.425ZM10.05 20.25l-5-5q-.45-.45-.45-1.05 0-.6.45-1.05.45-.45 1.05-.425.6.025 1.05.425l3.95 3.9 7.9-7.9q.45-.45 1.05-.425.6.025 1.05.475.45.45.45 1.05 0 .6-.45 1.05l-8.95 8.95q-.45.45-1.05.45-.6 0-1.05-.45Zm0 16-5-5q-.45-.45-.45-1.05 0-.6.45-1.05.45-.45 1.05-.425.6.025 1.05.425l3.95 3.9 7.9-7.9q.45-.45 1.05-.425.6.025 1.05.475.45.45.45 1.05 0 .6-.45 1.05l-8.95 8.95q-.45.45-1.05.45-.6 0-1.05-.45Z"
    />
  </svg>
</template>
